// V192 — Helpers for WhatsApp Fee Reminders.
export const PLACEHOLDER_RE = /\[([^[\]\n]{1,40})\]/g;

export const HEADING = "*Anand Tutorials | Fee Reminder*";
const HEAD_RE = /^[\s*_~]*anand\s+tutorials\s*\|\s*(.+?)[\s*_~]*$/i;

/** V195 — exactly one bold WhatsApp heading at the top (plain/odd variants normalised). */
export function withHeading(text = "") {
    const lines = text.replace(/^\n+/, "").split("\n");
    let heading = HEADING;
    const m = lines.length ? lines[0].match(HEAD_RE) : null;
    if (m) {
        heading = `*Anand Tutorials | ${m[1].trim()}*`;
        lines.shift();
        while (lines.length && !lines[0].trim()) lines.shift();
    }
    const rest = lines.join("\n");
    return rest.trim() ? `${heading}\n\n${rest}` : heading;
}

export const SKELETON = "*Anand Tutorials | Fee Reminder*\n\nDear Parents,\n\nGreetings from Anand Tutorials!\n\n[Your message]\n\nPlease feel free to contact us if you need any assistance.\n\nBest regards,\nAnand Tutorials";
export const COMMON_PLACEHOLDERS = ["Parent Name", "Student Name", "Outstanding Amount", "Due Date", "Payment Link"];

/** Unique placeholder names in a template body, in order of appearance. */
export function placeholdersOf(body = "") {
    return [...new Set([...body.matchAll(PLACEHOLDER_RE)].map((m) => m[1].trim()))];
}

export const isDateField = (name) => /date/i.test(name);

export function fmtDueDate(iso) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso || "")) return iso || "";
    return new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
}

/** Replace placeholders that have values; [Parent Name] falls back to "Sir/Ma'am". */
export function fillTemplate(body = "", values = {}) {
    return body.replace(PLACEHOLDER_RE, (whole, raw) => {
        const key = raw.trim();
        const v = (values[key] || "").trim();
        if (v) return isDateField(key) ? fmtDueDate(v) : v;
        if (key.toLowerCase() === "parent name") return "Sir/Ma'am";
        return whole;
    });
}

export const unresolvedIn = (text = "") => placeholdersOf(text).map((p) => `[${p}]`);

export const whatsappChatUrl = (phone, text) =>
    `https://wa.me/${String(phone).replace(/\D/g, "")}?text=${encodeURIComponent(text).replace(/\*/g, "%2A")}`;

export const prettyPhone = (digits = "") => (digits ? `+${digits}` : "");
